import React, { useEffect } from 'react'
import { usePage } from '@inertiajs/react'
import { toastUtils } from '@/utils/index.jsx'

const ToastMessages = () => {
  const { flash } = usePage().props

  useEffect(() => {
    if (flash.success) {
      toastUtils.success(flash.success)
    }

    if (flash.error) {
      toastUtils.error(flash.error)
    }

    if (flash.warning) {
      toastUtils.warning(flash.warning)
    }

    if (flash.info) {
      toastUtils.info(flash.info)
    }
  }, [flash])

  return (
    <></>
  )
}

export default ToastMessages
